module.exports = __webpack_public_path__ + "d0eb29db28b4edb1fb0189acba534775.svg";